import { DateFilterFn } from "@angular/material/datepicker";
export class AddInvoiceAdjustment {
    public constructor(init?: Partial<AddInvoiceAdjustment>) {
      Object.assign(this, init);
    }
        GenerateBillingLineItemId: string;
        LotNumber: string;
        InvoiceNumber: string;
        TransactionDate: Date;
        AdjustmentReasonId: number;
        AdjustmentAmount: number;
        Comments: string;
        UserName: string;
        IsLocked: boolean;
        DateEntered: Date;
        BillingDetailId: number;
        RevenueCode: string;
        AdjustmentPostingId: number;
        ManualInvoiceId: string;

   }